import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// 特效層
import EffectContainer from '@js/containers/Common/EffectContainer';

// component
import HeaderContainer from '@js/containers/Common/HeaderContainer';
import FooterContainer from '@js/commonComponents/FooterContainer/index';
import ProductContainer from '@js/containers/Layouts/page/ProductContainer';

// redux store
import store from '@js/store';

import '@scss/pages/product.scss';

// 測試首頁
render(
  <Provider store={store}>

    <BrowserRouter>
      <Suspense fallback={<div />}>
        <HeaderContainer />
        <main id="main">
          <ProductContainer />
        </main>
        <FooterContainer socialBlockType="johns" />
        <EffectContainer />
      </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('zh__food__product__detail'),
);
